// custom code start
(function () {
  if (window.Tracking && window.Tracking.init && window.Tracking.init.selectItem) return;
  var Tracking = window.Tracking || (window.Tracking = {});
  Tracking.init = Tracking.init || {};
  Tracking.init.selectItem = true;

  var SESSION_KEY_LAST_LIST = 'tracking:lastList';

  function push(payload) {
    if (typeof Tracking.push === 'function') {
      Tracking.push(payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  }

  function onClick(e) {
    if (!e.target.closest) return;

    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    var listContainer = link.closest('[data-tracking-list-id]');
    if (!listContainer) return;

    var handleMatch = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!handleMatch) return;
    var handle = handleMatch[1];

    var cache = Tracking.productCache || {};
    var item = cache[handle];
    if (!item) return;

    var listId = listContainer.getAttribute('data-tracking-list-id') || '';
    var listName = listContainer.getAttribute('data-tracking-list-name') || '';

    var enrichedItem = Object.assign({}, item, {
      item_list_id: listId,
      item_list_name: listName,
    });

    var event = {
      event: 'select_item',
      ecommerce: {
        item_list_id: listId,
        item_list_name: listName,
        items: [enrichedItem],
      },
    };
    if (Tracking.userId) event.user_id = Tracking.userId;
    push(event);

    try {
      sessionStorage.setItem(SESSION_KEY_LAST_LIST, JSON.stringify({
        listId: listId,
        listName: listName,
        handle: handle,
        t: Date.now(),
      }));
    } catch (err) {}
  }

  document.addEventListener('click', onClick, true);
})();
// custom code end